
export const LOGIN_IN = 'LOGIN_IN' // 登录

export const LOGIN_OUT = 'LOGIN_OUT' // 登出

export const CHANGE_COMPANYNAME = 'CHANGE_COMPANYNAME' //改变当前选择的企业

export const CHANGE_COMPANYS = 'CHANGE_COMPANYS' //改变拥有的企业

export const GET_USER_INFO = 'GET_USER_INFO' //用户信息